import { render, staticRenderFns } from "./SlideOverlay.vue?vue&type=template&id=a80b8624&scoped=true"
import script from "./SlideOverlay.vue?vue&type=script&lang=js"
export * from "./SlideOverlay.vue?vue&type=script&lang=js"
import style0 from "./SlideOverlay.vue?vue&type=style&index=0&id=a80b8624&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80b8624",
  null
  
)

export default component.exports